import { rootEpic } from "./epics.js";
import { getLoadAssignmentUnitsEpicReducer } from "./epics.js";
export {
  rootEpic as default,
  getLoadAssignmentUnitsEpicReducer,
  rootEpic
};
//# sourceMappingURL=index.js.map
